export const SET_SITES_DATA = 'SET_SITES_DATA';

export default SET_SITES_DATA;
